<template>
  <BModal size="md" body-class="p-5 rounded-lg" :visible="visible" hide-footer @hide="$emit('close', true)">
    <div class="text-center">
      <div class="shadow border rounded bg-white p-5 mb-3">
        <img
          style="width: 160px"
          class="d-block mx-auto mb-4"
          :src="industry == 'cannabis' ? '/img/logos/apex-logo.png' : '/img/logos/bushel-logo.png'"
          :alt="industry == 'cannabis' ? 'Apex Logo' : 'Bushel44 Logo'"
        />
        <h3 class="font-weight-bold gradient-text">{{ title }}</h3>
        <p class="text-dark mb-3">{{ description }}</p>

        <p class="text-dark mb-1">Need help? Reach out to our support team:</p>
        <div class="mt-2">
          <a :href="supportEmailLink" target="_blank" class="text-primary">{{ supportEmail }}</a>
          <br />
          971-444-6330
        </div>
        <BushelBtn class="mt-3 btn-sm" outline variant="primary" @click="openChat"> Live Chat </BushelBtn>
      </div>

      <div class="mt-3">
        <p class="font-weight-bold text-dark mb-1">Feel Free to Look Around</p>
        <div class="row mt-2">
          <BushelBtn class="col mx-2" variant="success" @click="goToMarketplace"> Browse marketplace </BushelBtn>
          <BushelBtn class="col mx-2" variant="success" @click="$emit('close', true)"> Browse This Vendor </BushelBtn>
        </div>
      </div>
    </div>
  </BModal>
</template>
<script>
export default {
  props: {
    visible: { type: Boolean, default: false },
    reason: { type: String, default: "" },
  },
  emits: ["close"],
  data() {
    return {
      industry: APP_INDUSTRY,
    };
  },
  computed: {
    title() {
      if (this.reason === "contact_not_in_crm") {
        return "Account Approval Required";
      }
      return "Account Pending Approval";
    },
    description() {
      if (this.reason === "contact_not_in_crm") {
        return "Your email is not whitelisted by this seller, so we need to manually approve your account before you can place an order. Expect to hear from us within 1-2 business hours.";
      }
      return "Your account must be approved before you can place an order.";
    },
    supportEmail() {
      return this.industry === "cannabis" ? "cs@apextrading.com" : "support@bushel44.com";
    },
    supportEmailLink() {
      return `mailto:${this.supportEmail}?subject=Account Approval Request`;
    },
  },
  methods: {
    goToMarketplace() {
      this.$emit("close", true);
      this.$router.push("/marketplace");
    },
    openChat() {
      if (window._chatlio) {
        window._chatlio.showOrHide();
      }
    },
  },
};
</script>
<style>
.gradient-text {
  background: linear-gradient(to right, var(--success), var(--primary) 60%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
